import { Deserializable } from '../deserializable';
import { BrokerUser } from './broker-user';
import { UserBilling } from './user-billing';
import { UserRole } from './user-role';
import { UserTradingBankAccount } from './user-trading-bank-account';
export class Users implements Deserializable {
    id: number;
    email: string;
    mobile: string;
    imei: string;
    active: boolean;
    isoCountryCode: string;
    createdDate: string;
    updatedDate: string;
    userRoles: UserRole[] = [];
    brokerUsers: BrokerUser[] =[];
    userBilling: UserBilling[] =[];
    userTradingBankAccounts: UserTradingBankAccount[] = [];

    deserialize(input: any): this {
        Object.assign(this, input);
        return this;
    }
}
